export const PAYROLL_GRID_CONTAINER_CLASS_NAME =
  "mb-24 h-[calc(100dvh-180px)] max-h-[1200px] min-h-[520px] min-w-0";
